import { render, staticRenderFns } from "./MenuGeneral.vue?vue&type=template&id=45a14a96&"
import script from "./MenuGeneral.vue?vue&type=script&lang=js&"
export * from "./MenuGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports